import { render, staticRenderFns } from "./selectApproval.vue?vue&type=template&id=00216c06&"
import script from "./selectApproval.vue?vue&type=script&lang=js&"
export * from "./selectApproval.vue?vue&type=script&lang=js&"
import style0 from "./selectApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports